shadow$provide[291] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, Move:{enumerable:true, get:function() {
  return Move;
}}});
var require$_DOT__SLASH_transition_DOT_js = require("./transition.js");
class Move extends require$_DOT__SLASH_transition_DOT_js.Transition {
  static initClass() {
    this.traits = ["node", "transition", "vertex", "move", "visible", "active"];
  }
  make() {
    super.make();
    const object = {moveFrom:this.node.attributes["move.from"], moveTo:this.node.attributes["move.to"],};
    for (const k in object) {
      const v = object[k];
      this.uniforms[k] = v;
    }
  }
  vertex(shader, pass) {
    let left;
    if (pass === this.props.pass) {
      shader.pipe("move.position", this.uniforms);
    }
    return (left = __guard__(this._inherit("vertex"), x => x.vertex(shader, pass))) != null ? left : shader;
  }
}
Move.initClass();
function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null ? transform(value) : undefined;
}

};